import { useT } from "../../i18n/LanguageProvider";
import {
  useOrderReferencePhotos,
  type ReferencePhotoMode,
} from "./useOrderReferencePhotos";

interface Props {
  orderId: string;
  /** Which auth plane fetches the bytes (TaskImages pattern). */
  mode?: ReferencePhotoMode;
  /** Extra class on each thumbnail — the floor builder styles them larger. */
  imageClassName?: string;
}

/**
 * G-15: the manager's reference photos for an order — the florist's visual
 * brief. The blob-URL lifetime lives in `useOrderReferencePhotos`, so no
 * caller has to manage it. A fetch failure renders nothing rather than
 * breaking the screen: the brief is helpful, never a gate.
 */
export function OrderReferencePhotos({
  orderId,
  mode = "crm",
  imageClassName = "sf-order-reference-image",
}: Props) {
  const { t } = useT();
  const urls = useOrderReferencePhotos(orderId, mode);

  if (urls.length === 0) return null;
  return (
    <div className="sf-order-reference-photos">
      {urls.map((url, index) => (
        <img
          key={url}
          src={url}
          alt={t("orderPhotos.referenceAlt", { index: index + 1 })}
          className={imageClassName}
        />
      ))}
    </div>
  );
}
